// eslint-disable-next-line import/no-extraneous-dependencies
import Cookies from 'js-cookie';

/**
 * path匹配到环境为止的正则
 * 例如: /ebike-h5/{env}
 */
const cookiePathReg = /\/[^/]+\/([^/]+\/)?/;
export const pathMatch = (pathname:string) => {
  const matches = pathname.match(cookiePathReg);
  if (matches) {
    return matches[0];
  }
  return pathname;
};

function getKey(key:string) {
  return `${key}_h5_${process.env.REACT_APP_ENV}`;
}

export const tld = (hostname:string) => {
  // 本地调试通过localhost或IP访问
  if (hostname === 'localhost'
    || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname;
  }
  return hostname.split('.').slice(1).join('.');
};

const getCurrentPath = () => pathMatch(window.location.pathname);

const getTopLevelDomain = () => tld(window.location.hostname);

export default class CookieUtil {
  static getItem(key:string) {
    return Cookies.get(getKey(key));
  }

  static setItem(key:string, val: string, expirationDate?: number) {
    if (val !== undefined) {
      return Cookies.set(getKey(key), val, {
        path: getCurrentPath(),
        domain: getTopLevelDomain(),
        expires: expirationDate || 3650,
      });
    }
    return undefined;
  }

  static removeItem(key:string) {
    Cookies.remove(getKey(key), {
      path: getCurrentPath(),
      domain: getTopLevelDomain(),
    });
  }
}
